const ASSISTANCE = 'assistance_detail'
const HOTEL = 'hotel_detail'
const CAR = 'car_detail'
const TRAIN_PASSES = 'train_detail_passes'
const TRAIN_SEGMENTS = 'train_detail_segment'
const AIR = 'air_detail'
const OTHER = 'other_detail'
const TRANFER = 'transfer_detail'
export { ASSISTANCE, HOTEL, CAR, TRAIN_PASSES, TRAIN_SEGMENTS, AIR, OTHER, TRANFER }
